import React from 'react';
import { PageWrapper } from './../../components';
import BlogLandingGrid from './blog_landing/BlogLandingGrid';
import { heights, widths, fonts } from './../../styles/theme.json';

const BlogLanding = (props) => {
  return (
    <PageWrapper>
      <BlogLandingGrid blogLandingData={props.data}/>
    </PageWrapper>
  );
};

export default BlogLanding;



// WEBPACK FOOTER //
// ./src/pages/blog/BlogLanding.js